/**
 * Назначение: legacy-редирект фитнес-контура на рабочий стол/расписание.
 * Кто: все сотрудники.
 * Вход: устаревшие ссылки /fitness и связанные.
 */

import { Navigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../app/router/route-paths';

/**
 * Ключ `/fitness` в `routes_allowed`: канон экрана — расписание занятий (path-only, без query для nginx).
 * Legacy-редирект: удалить когда все клиенты перейдут на /schedule и nginx не будет генерировать /fitness ссылки.
 */
export default function FitnessLegacyRedirectPage() {
  return <Navigate to={ROUTE_PATHS.schedule} replace />;
}
